// lib/styles/typographies.ts
import { css } from "@emotion/react";
var Typography = {
  Default: css`
    font-size: 1rem; // 16px
  `,
  InputValue: css`
    font-size: 0.75rem; // 12px
  `,
  SelectOption: css`
    font-size: 0.875rem; //14px
    line-height: 1;
  `,
  ListTitle: css`
    font-size: 0.625rem; // 10px
  `,
  CheckListLabel: css`
    font-size: 0.875rem;
    line-height: 1;
    letter-spacing: -0.015em;
  `,
  CheckListSubLabel: css`
    font-size: 0.625rem;
    line-height: 1;
    letter-spacing: -0.015em;
  `,
  FavListLabel: css`
    font-size: 0.75rem;
  `,
  Regular: css`
    font-size: 0.75rem;
  `,
  IconSmall: css`
    font-size: 0.75rem;
  `
};

export {
  Typography
};
